var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 654,
    height: 561,
    viewBox: "0 0 654 561",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3379_118)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M456.713 5.58726C367.926 13.5398 348.837 114.556 289.255 161.038C258.096 185.379 185.944 162.538 151.471 178.877C41.2968 231.16 21.0818 400.614 81.4142 479.99C233.625 432.108 211.663 572.486 322.994 555.947C434.325 539.409 513.105 532.206 600.657 432.108C702.517 315.65 658.386 -12.4765 456.713 5.58726Z",
    fill: "#7F92E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M549.155 492.974C549.155 492.974 497.687 568.365 408.9 560.412C320.114 552.46 301.025 451.444 241.443 404.963C210.284 380.622 138.132 403.462 103.659 387.124C-6.51567 334.84 -26.7307 165.386 33.6017 86.0105C150.476 -67.9226 443.871 9.3014 552.844 133.893C640.396 233.991 610.972 392.459 549.155 492.974Z",
    fill: "#667EEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3379_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 654,
    height: 561,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.3e32a32bb62f181df671cd8bc50ead13.svg";
export { ForwardRef as ReactComponent };